import type { FilterKey } from '@core/Entities/Search/QueryParams.entity';
import type { Filter } from '@core/Entities/Search/SearchFilters/Filter.entity';
import { getFilterFromArray } from '@core/Utils/SearchFilters/GetFilterFromArray';

export const getArrayFilterValue = (id: FilterKey, filters: Filter[]) => {
  const filter = getFilterFromArray(id, filters);

  return typeof filter?.value === 'string' ? [filter.value] : filter?.value;
};
